import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {IconArrowBack1} from "../../../../../icons/IconArrowBack1";
import {IconChevronDown1} from "../../../../../icons/IconChevronDown1";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const PixieOnboardingCardId = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_phone-pixie-mobile${currentParams}`);
  };

  return (
      <div className="pixie-onboarding-card-id">
        <div className="corporativo-6">
          <div className="molecula-stepper-2">
            <div className="content-6">
              <div className="numb-4">
                <div className="text-wrapper-13">1</div>
              </div>

              <div className="line-3" />
            </div>

            <div className="div-4">
              <div className="div-4">
                <div className="numb-5">
                  <div className="text-wrapper-14">2</div>
                </div>

                <div className="line-4" />
              </div>
            </div>

            <div className="div-4">
              <div className="div-4">
                <div className="numb-6">
                  <div className="element-3">3</div>
                </div>

                <div className="line-5" />
              </div>
            </div>

            <div className="div-4">
              <div className="div-4">
                <div className="numb-6">
                  <div className="element-3">4</div>
                </div>

                <div className="line-5" />
              </div>
            </div>

            <div className="div-4">
              <div className="div-4">
                <div className="numb-6">
                  <div className="element-3">5</div>
                </div>

                <div className="line-5" />
              </div>
            </div>

            <div className="content-wrapper">
              <div className="content-7">
                <div className="numb-6">
                  <div className="element-3">6</div>
                </div>
              </div>
            </div>
          </div>

          <div className="frame-12">
            <svg
                width={98}
                height={73}
                viewBox="0 0 98 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M80.5 73L64.1576 56.753C62.6141 55.2185 62.6141 52.7589 64.1576 51.247L80.5 35L96.8424 51.247C98.3859 52.7815 98.3859 55.2411 96.8424 56.753L80.5 73Z"
                  fill={colors.septimo}
              />
              <path
                  d="M24.5772 29.7454H18.547C13.3392 29.7582 9.12054 33.9769 9.10767 39.1847V42.2076C9.10767 42.7784 9.57046 43.2412 10.1413 43.2412H32.9789C32.9828 43.2412 32.9867 43.2412 32.9906 43.2412C33.5615 43.2369 34.0208 42.7706 34.0165 42.1998V39.1847C34.0036 33.9769 29.785 29.7582 24.5772 29.7454ZM31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z"
                  fill={colors.secundario}
              />
              <path
                  d="M31.9492 41.1661H11.1749V39.1847C11.1962 35.1221 14.4844 31.8339 18.547 31.8126H24.5772C28.6398 31.8339 31.9279 35.1221 31.9492 39.1847V41.1661Z"
                  fill={colors.secundario}
              />
              <path
                  d="M69.8705 39.0054H42.1766C41.6557 39.0374 41.2405 39.4528 41.2085 39.9735C41.1734 40.5434 41.607 41.0336 42.1766 41.0688H69.8705C70.3914 41.0368 70.8066 40.6214 70.8386 40.1006C70.8737 39.5308 70.4403 39.0405 69.8705 39.0054Z"
                  fill={colors.secundario}
              />
              <path
                  d="M26.4223 26.3287L26.4848 26.2702C26.4855 26.2694 26.4863 26.2686 26.4873 26.2676C29.2056 23.548 29.2046 19.1396 26.4848 16.4213C25.1812 15.1123 23.4098 14.3767 21.5623 14.3774C19.7435 14.3767 17.997 15.0895 16.6983 16.3628L16.6359 16.4213C16.6351 16.4221 16.6343 16.4229 16.6334 16.4239C13.9151 19.1435 13.9161 23.5519 16.6359 26.2702C19.3302 28.9699 23.6961 28.9961 26.4223 26.3287ZM18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z"
                  fill={colors.secundario}
              />
              <path
                  d="M18.1064 17.8879L18.1571 17.8372C20.0797 15.9837 23.1311 16.0061 25.026 17.8879L25.0377 17.884C26.9507 19.7984 26.9507 22.9009 25.0377 24.8153L24.9869 24.866C23.064 26.7283 20.0038 26.7074 18.1064 24.8192C16.1934 22.9048 16.1934 19.8023 18.1064 17.8879Z"
                  fill={colors.secundario}
              />
              <path
                  d="M73.1156 0H6.88445C3.08669 0.0107265 0.0107265 3.08669 0 6.88445V50.7343C0.0107265 54.532 3.08669 57.608 6.88445 57.6187H73.1156C76.9133 57.608 79.9893 54.532 80 50.7343V6.88445C79.9893 3.08669 76.9133 0.0107265 73.1156 0ZM77.9366 50.7343C77.928 53.3933 75.7745 55.5468 73.1156 55.5553H6.88445C4.22545 55.5468 2.07196 53.3933 2.06338 50.7343V6.88445C2.07196 4.22545 4.22545 2.07196 6.88445 2.06338H73.1156C75.7745 2.07196 77.928 4.22545 77.9366 6.88445V50.7343Z"
                  fill={colors.secundario}
              />
              <path
                  d="M69.8703 16.554H42.1765C41.6556 16.5859 41.2403 17.0013 41.2082 17.5223C41.1731 18.0921 41.6066 18.5824 42.1765 18.6173H69.8703C70.3912 18.5854 70.8064 18.1699 70.8386 17.649C70.8735 17.0794 70.4402 16.5891 69.8703 16.554Z"
                  fill={colors.secundario}
              />
              <path
                  d="M69.8703 27.7795H42.1765C41.6556 27.8115 41.2403 28.2269 41.2082 28.7478C41.1731 29.3177 41.6066 29.808 42.1765 29.8429H69.8703C70.3912 29.8109 70.8064 29.3955 70.8386 28.8746C70.8735 28.3049 70.4402 27.8146 69.8703 27.7795Z"
                  fill={colors.secundario}
              />
              <path
                  d="M69.8703 22.1667H42.1765C41.6556 22.1987 41.2403 22.6141 41.2082 23.1351C41.1731 23.7049 41.6066 24.1952 42.1765 24.2301H69.8703C70.3912 24.1981 70.8064 23.7827 70.8386 23.2618C70.8735 22.6922 70.4402 22.2019 69.8703 22.1667Z"
                  fill={colors.secundario}
              />
              <path
                  d="M69.8705 33.3926H42.1766C41.6557 33.4246 41.2405 33.84 41.2085 34.3607C41.1734 34.9306 41.607 35.4209 42.1766 35.456H69.8705C70.3914 35.424 70.8066 35.0086 70.8386 34.4878C70.8737 33.918 70.4403 33.4277 69.8705 33.3926Z"
                  fill={colors.secundario}
              />
            </svg>
            <div className="frame-13">
              <div className="frame-14">
                <div className="frame-15">
                  <p className="subtitle-11">Now, get your ID card</p>
                </div>

                <p className="subtitle-12">
                  We will take a photo of the front &amp; back.
                  <br />
                  <br />
                  Center your document in the frame and please make sure it
                  doesn´t show any glare or shadows.
                  <br />
                  <br />
                  Photos will be captured automatically.
                </p>
              </div>
            </div>

            <div className="input">
              <div className="e-mail">Country</div>

              <div className="frame-16">
                <div className="frame-17">
                  <div className="text-wrapper-15">Select your country</div>

                  <IconChevronDown1
                      className="icon-chevron-down"
                      color="#5C5C5C"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="action-buttons-3 highlighted-button">
            <div className="test-button-4" onClick={handleButtonClick}>
              <p className="text-wrapper-16">I´ve got my ID card!</p>
            </div>
          </div>

          <header className="header-3">
            <div className="overlap-9">
              <div className="frame-18">
                <div className="icon-arrow-back-1-wrapper">
                  <IconArrowBack1 className="icon-arrow-back-1-instance" />
                </div>

                <div className="subtitle-13">Scan ID Card</div>
              </div>
            </div>
          </header>
        </div>
      </div>
  );
};
